import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#e8eaed" viewBox="0 -960 960 960">
      <path
        fill={props.fill || '#1D252D'}
        d="M520-140q-67.85 0-128.31-25.19-60.46-25.2-107.53-69.73l43.15-42.77q38.77 36.23 87.42 56.96Q463.38-200 520-200q116.38 0 198.19-81.81T800-480q0-116-82-198t-198-82q-116 0-198 82t-82 198v31.23l79.54-79.54 42.77 41.77L210-334.23 57.69-486.54l42.77-41.77L180-447.77V-480q0-70.8 26.77-132.63t72.77-107.83q46-46 107.82-72.77Q449.19-820 519.98-820t132.63 26.77q61.85 26.77 107.85 72.77 46 46 72.77 107.82Q860-550.82 860-480.03q0 141.57-99.17 240.8Q661.67-140 520-140zm-80-184.62q-16.02 0-26.86-10.83-10.83-10.84-10.83-26.86v-120q0-16.02 11.5-26.85 11.5-10.84 28.5-10.84v-42.31q0-32.05 22.82-54.87T520-640q32.05 0 54.87 22.82t22.82 54.87V-520q17 0 28.5 10.84 11.5 10.83 11.5 26.85v120q0 16.02-10.83 26.86-10.84 10.83-26.86 10.83H440zM477.69-520h84.62v-42.16q0-17.92-12.27-30.19T520-604.62q-17.77 0-30.04 12.27t-12.27 30.19V-520z"
      ></path>
    </svg>
  );
}

export default Icon;
